import React from 'react';
import { observable, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';

@observer
class Collapsible extends React.Component {
	@observable itemCollapsed = false;
	constructor(props) {
        super(props);
        makeObservable(this);
        const { expanded } = this.props;
        if (expanded !== undefined) {
			this.itemCollapsed = expanded;
		}
        this.togglePanel = this.togglePanel.bind(this);
    }
	togglePanel(e) {
		this.itemCollapsed = !this.itemCollapsed;
	}
	render() {
		return (
			<div className="order__box">
				<div className="order__box__title cursor--pointer" onClick={e => this.togglePanel(e)}>
					<h4 className="spc--right--sml">{this.props.title}</h4>
					<i
						className={
							this.itemCollapsed
								? 'fa fa-angle-up k-custom-clickable'
								: 'fa fa-angle-down k-custom-clickable'
						}
					></i>
				</div>
				{this.itemCollapsed ? <div className="order__box__content order__box__content--no-padd">{this.props.children}</div> : null}
			</div>
		);
	}
}

export default Collapsible;
